import {
  BASE_URL,
  USERS_DATA,
  USER,
  USERINFO,
  ROLE,
  ROLE_PAGE,
  ERROR_MSG,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchUsersData = async (pageNo, recordsPerPage) => {
  let response = await fetch(
    `${BASE_URL}${USERS_DATA}/${pageNo}/${recordsPerPage}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchUserById = async (userId) => {
  let response = await fetch(`${BASE_URL}${USER}/${userId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const fetchUserByUserName = async (userName) => {
  let response = await fetch(`${BASE_URL}${USER}${USERINFO}/${userName}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const fetchRolesData = async () => {
  let response = await fetch(`${BASE_URL}${ROLE}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const updateUserRecord = async (form) => {
  let response = await fetch(`${BASE_URL}${USER}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};

export const fetchRoles = async (pageNo, recordsPerPage) => {
  let response = await fetch(
    `${BASE_URL}${ROLE_PAGE}/${pageNo}/${recordsPerPage}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchRoleById = async (roleId) => {
  let response = await fetch(`${BASE_URL}${ROLE}/${roleId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};
